import { useState, useRef } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";

import MonthDropdown from "../../../../components/inputs/MonthDropdown";
import YearDropdown from "../../../../components/inputs/YearDropdown";

import { getBankTransferXMLs } from "../../../../services/clearing/credit-notes";
import { promptFileDownload } from "../../../../utils/fileDownload";
import { MONTHS_OPTIONS } from "../../../../components/inputs/consts";

const today = new Date();
const currentMonth = today?.getMonth();
const currentYear = today?.getFullYear();

const BankTransferXmlsButton = () => {
  const [visible, setVisible] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [selectedYear, setSelectedYear] = useState(currentYear);

  const toast = useRef(null);

  const handleDownload = async () => {
    setIsDownloading(true);
    setVisible(false);

    toast.current.show({
      severity: "info",
      summary: "Download Initiated",
      detail: `Download initiated for XMLs of ${MONTHS_OPTIONS.find((m) => m.code === selectedMonth).name
        } ${selectedYear}`,
      life: 3000,
    });

    const xmlBlob = await getBankTransferXMLs({
      month: selectedMonth,
      year: selectedYear,
    });

    setIsDownloading(false);

    if (!xmlBlob) {
      toast.current.show({
        severity: "error",
        summary: "Download Failed",
        detail: `Could not get XMLs for ${MONTHS_OPTIONS.find((m) => m.code === selectedMonth).name
          } ${selectedYear}`,
        life: 3000,
      });
      return;
    }

    toast.current.show({
      severity: "success",
      summary: "Download Complete",
      detail: `XMLs for ${MONTHS_OPTIONS.find((m) => m.code === selectedMonth).name
        } ${selectedYear} downloaded successfully!`,
      life: 3000,
    });

    promptFileDownload(xmlBlob, "cocharge_bank_transfer.xml");
  };

  const footerContent = (
    <div>
      <Button
        label="Cancel"
        icon="pi pi-times"
        onClick={() => setVisible(false)}
        className="p-button-text"
      />
      <Button
        label="Download"
        icon="pi pi-download"
        onClick={handleDownload}
        autoFocus
      />
    </div>
  );

  return (
    <>
      <Toast ref={toast} />
      <Button
        className="md:w-12rem"
        label="Download bank transfer XMLs"
        icon="pi pi-building-columns"
        onClick={() => setVisible(true)}
        loading={isDownloading}
      />
      <Dialog
        header="Select Period for XML Download"
        visible={visible}
        style={{ width: "30rem" }}
        onHide={() => setVisible(false)}
        footer={footerContent}
      >
        <div className="grid">
          <div className="col-12 md:col-6">
            <MonthDropdown
              monthIndex={selectedMonth}
              onChange={(option) => setSelectedMonth(option.code as number)}
              placeholder="Select Month"
              className="w-full"
            />
          </div>
          <div className="col-12 md:col-6">
            <YearDropdown
              year={selectedYear}
              onChange={(option) => setSelectedYear(option.code as number)}
              placeholder="Select Year"
              className="w-full"
              yearsOffset={2}
            />
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default BankTransferXmlsButton;
